import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import {Box, FormHelperText, MenuItem} from '@mui/material';
import DividerWithText from '../../../../../components/DividerWithText';
import {SPEED_UNIT_MODEL} from "../Model/Model";
import {CustomStyleFormHelperText} from "../../../../../components/Styles";
import React from "react";
import {IconCheckboxUnchecked} from "../../../../../components/buttons/IconButtons";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const DetailsStep = ({ disabled, handleChange, emptyFields, item, t }) => {
    const isValidUserScope = (item?.applyEmployee || item?.applySupplier || item?.applyContractor);
    const uncheckedUserScopeIcon = emptyFields && !isValidUserScope ? <IconCheckboxUnchecked className={"icon-color-error-code-600"}/>: undefined;
    return (
        <>
            <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                <CustomTextField
                    id='txt_ds_name'
                    name='name'
                    trans='name'
                    required={true}
                    onChange={handleChange}
                    value={item?.name}
                    emptyFields={emptyFields}
                    disabled={disabled}
                />
            </Box>

            <div className={"col-12"}>
                <DividerWithText title={t('speed_management')} />
            </div>

            <div className='row mt-4'>
                <Box className='col-12 col-md-2 mt-2'>
                    <p className='fs-12px ibl-font-w-400'>{t('speed_unit')}</p>
                </Box>

                <Box className='col-12 col-md-4'>
                    <CustomSelectAndChildren
                        id='slt_ds_speed_unit'
                        name='speedUnit'
                        trans='speed_unit'
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        value={item?.speedUnit || ""}
                        required={true}
                        showNoSelectionOption={false}
                    >
                        {Object.entries(SPEED_UNIT_MODEL).map(([key, unit]) => (
                            <MenuItem key={unit.id} value={unit.id}>
                                {t(unit.name)}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </Box>
            </div>
            <div className='row '>
                <Box className='col-12 col-md-2 mt-2'>
                    <p className='fs-12px ibl-font-w-400'>{t('set_speed_limit')}</p>
                </Box>
                <Box className='col-12 col-md-4'>
                    <CustomTextField
                        id='txt_ds_speed_limit'
                        name='speedLimit'
                        trans='speed_limit'
                        placeholder={t('enter_maximum_allowed_speed')}
                        type='number'
                        required={true}
                        onChange={handleChange}
                        inputProps={{ min: 0 }}
                        length={3}
                        value={item?.speedLimit}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />
                </Box>
            </div>
            <div className='row '>
                <Box className='col-12 col-md-2 mt-2'>
                    <p className='fs-12px ibl-font-w-400'>{t('set_tolerance_speed_limit')}</p>
                </Box>

                <Box className='col-12 col-md-4'>
                    <CustomTextField
                        id='txt_ds_speed_tolerance'
                        name='speedTolerance'
                        trans='speed_tolerance'
                        type='number'
                        placeholder={t('enter_maximum_allowed_speed')}
                        required={true}
                        onChange={handleChange}
                        inputProps={{ min: 0 }}
                        length={3}
                        value={item?.speedTolerance}
                        emptyFields={emptyFields}
                        disabled={disabled}
                    />
                </Box>
            </div>
            <Box className='col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                <CustomTextField
                    id='txt_ds_description'
                    name='description'
                    value={item?.description}
                    trans='description'
                    onChange={handleChange}
                    length={512}
                    required={false}
                    multiline
                    rows={3}
                    disabled={disabled}
                />
            </Box>

            <div className={"col-12 mb-2"}>
                <DividerWithText title={t('user_scope')} />
            </div>

            <Box className='col-12 px-0'>
                <CustomCheckbox
                    id='cb_ds_apply_employees'
                    marginbutton={true}
                    labelId={'lbl_ds_apply_employees'}
                    label={'employees'}
                    trans={'employees'}
                    name={'applyEmployee'}
                    checked={item?.applyEmployee}
                    onChange={(e) => handleChange(e)}
                    icon={uncheckedUserScopeIcon}
                    disabled={disabled}
                />
            </Box>
            <Box className='col-12 px-0'>
                <CustomCheckbox
                    id='cb_ds_apply_contractor'
                    marginbutton={true}
                    checked={item?.applyContractor}
                    onChange={(e) => handleChange(e)}
                    labelId={'lbl_ds_apply_contractor'}
                    label={'contractors'}
                    trans={'contractors'}
                    name={'applyContractor'}
                    icon={uncheckedUserScopeIcon}
                    disabled={disabled}
                />
            </Box>
            <Box className='col-12 px-0'>
                <CustomCheckbox
                    id='cb_ds_apply_supplier'
                    marginbutton={true}
                    checked={item?.applySupplier}
                    onChange={(e) => handleChange(e)}
                    labelId={'lbl_ds_apply_supplier'}
                    label={'suppliers'}
                    trans={'suppliers'}
                    name={'applySupplier'}
                    icon={uncheckedUserScopeIcon}
                    disabled={disabled}
                />
            </Box>

            <div className={"col-12"}>
                <FormHelperText error={true} sx={CustomStyleFormHelperText(false)}>
                    {emptyFields && !isValidUserScope && t('select_at_least_one_option')}
                </FormHelperText>
            </div>
        </>
    );
};

export default DetailsStep;
